@if (!noBack) {
  @if (back) {
    <button mat-button [routerLink]="link" (click)="closing.emit()">
      <mat-icon mat-list-icon>chevron_left</mat-icon>
      {{ backButton ? 'Back' : 'Close' }}
    </button>
  } @else {
    <button mat-button (click)="closing.emit()">
      <mat-icon mat-list-icon>chevron_left</mat-icon>
      {{ backButton ? 'Back' : 'Close' }}
    </button>
  }

  <mat-divider></mat-divider>
}

<header>
  <div>{{ title }}</div>
  <ng-content select="[la-panel-header-actions]"></ng-content>
</header>

@if (subtitle) {
  <section>{{ subtitle }}</section>
}

<ng-content></ng-content>
